import { Tooltip, TooltipInteractiveWrapper, TooltipProps } from '@razorpay/blade/components';
import React from 'react';

export type BladeTooltipWrapperProps = TooltipProps & {
  children: React.ReactNode;
  shouldAddInteractiveWrapper?: boolean;
};
export const BladeTooltipWrapper = (
  props: TooltipProps & {
    shouldAddInteractiveWrapper?: boolean;
    tooltipInteractiveWrapperProps?: React.ComponentProps<typeof TooltipInteractiveWrapper>;
  },
) => {
  const {
    children,
    shouldAddInteractiveWrapper = true,
    tooltipInteractiveWrapperProps,
    ...tooltipProps
  } = props;

  if (props.content) {
    return (
      <Tooltip placement="top" {...tooltipProps}>
        {shouldAddInteractiveWrapper ? (
          <TooltipInteractiveWrapper {...tooltipInteractiveWrapperProps}>
            {children}
          </TooltipInteractiveWrapper>
        ) : (
          children
        )}
      </Tooltip>
    );
  }
  return children;
};
